<app-header></app-header>
<p-toast></p-toast>
<p-confirmPopup></p-confirmPopup>
<div class="DashmainContainer">
	<form [formGroup]="upgradeForm" (ngSubmit)="onSubmit()">
		<div class="col-md-12 col-xs-12 font16px mbrshipSection">
			<!-- <div>
				<h3 class="select-planhead">Change Your Plan Below:</h3><br>
			</div> -->

			<!-- <div>
				<ul class="nav nav-pills" id="nav-tab">
					<li class="nav-item" *ngFor="let category of uniquePlanCategories; let i = index">
						<a [class.active]="category === selectedCategory" (click)="selectCategory(category)"
							class="nav-item nav-link" role="tab">{{category}}</a>
					</li>
				</ul>
				<div class="tab-content plan-area" id="nav-tabContent">
					<div *ngFor="let plan of realtorPlans; let i = index" class="tab-pane fade show"
						[ngClass]="{ active: plan.planCategoryDescription === selectedCategory }">
						<div class="rdio rdio-primary radio-inline">
							<input [id]="'radio-' + i" type="radio" name="membershipPlan" [value]="plan.code"
								[ngClass]="{'is-invalid': submitted && form.membershipPlan.errors}"
								(change)="radioChecked(plan, i)" [checked]="plan.selected">
							<label [for]="'radio-' + i" [innerHTML]="plan.description" style="width: 100%;">

							</label>
							<div *ngIf="plan.featureSet?.AllowZipCodes === 'Yes'">
								<input
									[id]="'zipCode-' + i"
									type="text"
									class="form-control zipCode"
									formControlName="zipCode"
									[placeholder]="'Choose Up To ' + plan.limits.MaxZipCodeAllowed + ' Zip Codes Separated By Commas'"
									(focus)="radioChecked(plan, i)">
								<div style="margin-left: 34px;"
									*ngIf="plan.selected && submitted && form.zipCode.errors?.invalidZipCodes"
									class="error invalid-feedback">
									Invalid zip codes: {{ submitted && form.zipCode.errors?.invalidZipCodes.join(', ')
									}}
								</div>
								<div style="margin-left: 34px;"
									*ngIf="plan.selected && submitted && form.zipCode.errors?.maxZipCodesExceeded"
									class="error invalid-feedback">
									Maximum {{ submitted && plan.limits.MaxZipCodeAllowed }} zip
									codes are allowed. You provided {{
									submitted && form.zipCode.errors?.maxZipCodesExceeded.actual }}.
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="invalid-feedback" *ngIf="submitted && form.membershipPlan.errors?.required">
					<span>Please select a plan</span>
				</div>
			</div> -->
			<app-payment-onhold-alert source="inputs" [status]="currentPlanStatus" [holdStartDate]="currentPlanHoldStartDate"></app-payment-onhold-alert>
			<!-- <p class="membership-note" *ngIf="currentPlanBannerLabel" style="background-color:#eafaf1; border-color:#a9dfbf; color:#1e6b3a;">
				<strong>Current Plan:</strong> {{currentPlanBannerLabel}}
			</p> -->
			 <!-- domii membership info block -->
  <p class="membership-note">
    <strong>* domii® Membership:</strong>
    To take advantage of the mobile, domii® platform you must be a licensed,
    state-approved real estate agent/broker and belong to one of the following
    organizations: Realtor Association, Multiple Listing Service, and/or a
    Real Estate Brokerage agency.
  </p>		
			<div>
				<div *ngFor="let category of uniquePlanCategories">
					<div style="display: inline-block;
											font-weight: 400;
											color: #212529;
											text-align: center;
											vertical-align: middle;
											-webkit-user-select: none;
											user-select: none;
											background-color: transparent;
											border: 1px solid transparent;
											padding: .375rem .75rem;
											font-size: 1rem;
											line-height: 1.5;
											border-radius: .25rem; color: #fff;
											background-color: #f75a72;
											border-color: #f75a72;
											margin: 15px 0px;">{{category}}</div>
					<div *ngIf="category === 'domii® Seller Prospect Options'">
						<p style="font-size: 16px; font-weight: 600; color: #212529; margin-bottom: 15px;">
							We are excited to share our prospects with you exclusively. You can choose just AI Seller Prospects, or
							AI Seller
							Prospects combined with our online, Live Lead Strategy prospects. AI Seller prospects are algorithmic
							and forecast
							which homeowners may be selling within the next 12 months.
							<span *ngIf="showMoreInfo">
								Our online, Live Leads are derived from keyword marketing to those homeowners that respond from ads
								that say,
								“thinking of selling, need a market evaluation, what’s your home worth, real estate questions, etc.
								These prospects
								have agreed to be contacted by a Realtor as soon as possible. Exclusive to you.
							</span>
							<span style="color: #007bff; cursor: pointer;" (click)="toggleMoreInfo()">
								{{ showMoreInfo ? 'less...' : 'more...' }}
							</span>
						</p>
					</div>
					<div *ngFor="let plan of realtorPlans; let i = index">
						<div class="plan-area" id="nav-tabContent" *ngIf="plan.planCategoryDescription === category">
							<div class="plan-item" [class.plan-item--current]="!!plan.currentPlanStatus">
								<div class="rdio rdio-primary radio-inline">
									<input [id]="'radio-' + i" type="radio" name="membershipPlan" [value]="plan.code"
										[ngClass]="{'is-invalid': submitted && upgradeForm.get('membershipPlan')?.errors}"
										(change)="radioChecked(plan, i)" [checked]="plan.selected"
										[disabled]="!!plan.currentPlanStatus">
									<label [for]="'radio-' + i" [innerHTML]="cleanDescription(plan.description)" style="width: 100%;"></label>
									<span *ngIf="plan.currentPlanStatus" class="badge--current-plan">Current Plan</span>
									<div *ngIf="plan.featureSet?.AllowZipCodes === 'Yes'"
										style="border-bottom: 4px solid #000; padding-bottom: 15px;">
										<input [id]="'zipCode-' + i" type="text" class="form-control zipCode"
											formControlName="zipCode"
											[placeholder]="plan.limits.MaxZipCodeAllowed == 1 ? 'Choose Your Preferred Zip Code' : ('Choose Up To ' + plan.limits.MaxZipCodeAllowed + ' Zip Codes Separated By Commas')">
											<!-- (focus)="radioChecked(plan, i)" -->
										<div style="margin-left: 34px;"
											*ngIf="plan.selected && submitted && upgradeForm.get('zipCode')?.errors?.zipCodeRequired"
											class="error invalid-feedback">
											At least 1 zip code is required for this plan.
										</div>
										<div style="margin-left: 34px;"
											*ngIf="plan.selected && submitted && upgradeForm.get('zipCode')?.errors?.invalidZipCodes"
											class="error invalid-feedback">
											Invalid zip codes: {{ submitted &&
											upgradeForm.get('zipCode')?.errors?.invalidZipCodes.join(', ') }}
										</div>
										<div style="margin-left: 34px;"
											*ngIf="plan.selected && submitted && upgradeForm.get('zipCode')?.errors?.maxZipCodesExceeded"
											class="error invalid-feedback">
											Maximum {{ submitted && plan.limits.MaxZipCodeAllowed }} zip codes are allowed.
											You provided {{ submitted &&
											upgradeForm.get('zipCode')?.errors?.maxZipCodesExceeded.actual }}.
										</div>
									</div>
								</div>
							</div>
						</div>
						<ng-template #otherPlan></ng-template>
					</div>
					<div class="invalid-feedback" *ngIf="submitted && form.membershipPlan.errors?.required">
						<span>Please select a plan</span>
					</div>
				</div>
			</div>
			<div>
				<div class="row">
					<div class="form-group col-sm-4">
						<div style="width: 100%;">
							<label for="promocode" style="font-size: large; font-weight: bold; ">PROMO CODE</label>
							<div *ngIf="errorPromoCodeMessage !== ''"
								style="float:right; font-size: small; font-weight: bolder; margin-right: 70px; color: #ce0000 !important; ">
								<span>{{errorPromoCodeMessage}}</span>
							</div>
							<div *ngIf="validPromoCodeMessage !== ''"
								style="float:right; font-size: small; font-weight: bolder; margin-right: 70px; color: #28a745 !important; ">
								<span>{{validPromoCodeMessage}}</span>
							</div>
						</div>
						<div class="input-group mb-3">
							<input type="text" formControlName="promocode" class="form-control" placeholder="Promo Code"
								aria-label="Promo Code" aria-describedby="basic-addon2" [disabled]="upgradeForm.get('promocode')?.disabled" (input)="onPromoCodeInput()" />
							<div class="input-group-append">
								<button class="btn btn-primary btn-outline-secondary" type="button"
									(click)="onApplyPromoCode()" [disabled]="upgradeForm.get('promocode')?.disabled">Apply</button>
							</div>
						</div>
						 <!-- Optional helper note when disabled -->
    <small *ngIf="upgradeForm.get('promocode')?.disabled" style="color:#6c757d">
      Promo codes are not applicable for this plan.
    </small>
					</div>
				</div>
			</div>
			<div *ngIf="selectedPlan !== 'Free' || (selectedPlan === 'Free' && isTrialPromo())">
				<small *ngIf="isTrialPromo() && selectedPlan === 'Free'"
         style="display:block; margin:8px 0 10px; font-size: 14px; line-height: 1.4; color:#333;">
    Free today. Auto-renews at $19/month after 30 days until you cancel.
  </small>
				<div id="dropin-container"></div>
			</div>
			<div class="flexDspl agree-termarea">
				<div class="custom-control custom-checkbox">
					<input class="custom-control-input" type="checkbox" formControlName="agreeTandC"
						id="agreeTandCCheck">
					<label class="custom-control-label" for="agreeTandCCheck">
						I Agree to all the
						<span class="tCtext" (click)="openTerms($event, 'TC')">Terms and
							Conditions</span>
						and
						<span class="tCtext" (click)="openTerms($event, 'PP')">Privacy Policy</span>
					</label>
				</div>
			</div>
			<span class="invalid-feedback" *ngIf="submitted && form.agreeTandC.errors">*Please accept the
				Terms</span>
			<div class="flexDspl row" style="margin-bottom: 150px;">
				<div class="col-md-6 col-xs-12 ipadfullwidth">
					<button type="submit" class="btn submitButtonnew">SUBMIT</button>
				</div>
			</div>
		</div>
	</form>
</div>
<button id="failedBtn" [hidden]="true" data-toggle="modal" data-target="#paymentFailed">Payment Failed</button>
<div class="modal fade" id="paymentFailed" tabindex="-1" role="dialog" aria-labelledby="Payment Failed"
	aria-hidden="true" data-backdrop="static" data-keyboard="false" #paymentFailed>
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content confirmationModal">
			<div class="textCenter">
				<img src="../../../assets/images/stop_hand.svg" alt="Payment Failed" class="cnfrmImg">
			</div>
			<div class="martop20px cnfrmMsg text-center">
				<strong [innerHTML]="errorMessage"></strong>
			</div>
			<div class="martop20px cnfrmMsg text-center" *ngIf="errorHasButton">
				<button class="btn btn-primary btn-outline-secondary" type="button" data-dismiss="modal">Retry</button>
			</div>
		</div>
	</div>
</div>
<button id="successBtn" [hidden]="true" data-toggle="modal" data-target="#paymentSuccess">Payment Success</button>
<div class="modal fade" id="paymentSuccess" tabindex="-1" role="dialog" aria-labelledby="Payment Success"
	aria-hidden="true" data-backdrop="static" data-keyboard="false" #paymentSuccess>
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content"
			style="background-color: #f75a72; align-items: center; padding: 1%; font-weight: 600; border-top-left-radius: 30px; border-top-right-radius: 30px;">
			<div style="width: 100%;">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"
					style="float:right; color: #fff; opacity: inherit; margin-top: 2%; margin-right: 2%;"
					(click)="reloadPage()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="textCenter">
				<h2 class="text-white">NEXT STEP</h2>
			</div>
			<div class="textCenter" style="background-color: #fff; padding: 2%; min-width: 100%;">
				<!-- <h5 style="color: #f75a72; margin-top: 20px;">If you have not downloaded the<br />
					domii<sup>&#174;</sup> app, please download it now<br />
					by tapping the App Store and Google<br />
					Play Store links below.</h5><br />
				<img src="../../../assets/images/download-apple-store.png" alt="app store" class="appStore"
					(click)="openAppStore()" style="width: 250px" /><br /><br />
				<img src="../../../assets/images/download-google-play.png" alt="play store" class="playStore"
					(click)="openPlayStore()" style="width: 250px" /> -->
				<h5 style="color: #f75a72; margin: 30px;">{{upgradeDescription}}</h5>
			</div>
		</div>
	</div>
</div>
<button id="openTermsConditionsBtn" [hidden]="true" data-toggle="modal" data-target="#termsConditions">T&C</button>
<div class="modal fade" id="termsConditions" tabindex="-1" role="dialog" aria-labelledby="Terms and Conditions"
	aria-hidden="true" #termsConditions>
	<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header col-xs-12 col-md-12 modalTitle">
				<div class="col-md-4 col-xs-4 padnull">
					<img src="" alt="Logo" id="t&CLogo" class="tcLogo">
				</div>
				<span class="col-md-4 col-xs-4 textCenter">{{tcHeader}}</span>
				<div class="col-md-4 col-xs-4" style="text-align: end;">
					<img src="../../../assets/images/cross.svg" data-toggle="modal" data-target="#termsConditions">
				</div>
			</div>
			<div class="modal-body">
				<iframe *ngIf="tcURL" [src]="tcURL" class="tcIFrame"></iframe>
			</div>
		</div>
	</div>
</div>
<app-footer></app-footer>